import { useState, useEffect } from 'react';
import { fetchLeads, deleteLeads } from '../../services/AdminLeadService';
import { fetchBoats } from '../../services/AdminBoatService';
import { exportLeadsToCSV } from '../../utils/LeadsExportCSV';

const useLeadActions = () => {
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [boats, setBoats] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    filterLeads();
  }, [searchTerm, leads]);

  const clearSelectedLeads = () => {
    const updatedLeads = filteredLeads.map(lead => ({
      ...lead,
      isSelected: false
    }));
    setFilteredLeads(updatedLeads);
    setSelectedLeads([]);
  };

  const loadInitialData = async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        loadLeads(),
        loadBoats()
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const loadLeads = async () => {
    try {
      const data = await fetchLeads();
      setLeads(data);
      setFilteredLeads(data);
    } catch (error) {
    }
  };

  const loadBoats = async () => {
    try {
      const data = await fetchBoats();
      setBoats(data);
    } catch (error) {
    }
  };

  const handleBulkDelete = async (selectedLeads) => {
    try {
      const leadIds = selectedLeads.map(lead => lead.id);
      await deleteLeads(leadIds);
    } catch (error) {
    }
  };

  const handleExport = () => {
    const leadsToExport = leads.filter(lead =>
      selectedLeads.some(selectedLead => selectedLead.id === lead.id)
    );
    exportLeadsToCSV(leadsToExport);
  };

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const filterLeads = () => {
    let filtered = leads;

    if (searchTerm) {
      filtered = filtered.filter(lead =>
        lead.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lead.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lead.status.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredLeads(filtered);
  };

  const handleSelectAll = (isSelected) => {
    const updatedLeads = filteredLeads.map(lead => ({
      ...lead,
      isSelected: isSelected
    }));

    setFilteredLeads(updatedLeads);
    setSelectedLeads(isSelected ? filteredLeads : []);
  };

  const handleLeadSelect = (leadId, isSelected) => {
    const updatedLeads = filteredLeads.map(lead =>
      lead.id === leadId ? {
        ...lead,
        isSelected: isSelected
      } : lead
    );

    setFilteredLeads(updatedLeads);

    if (isSelected) {
      const selectedLead = filteredLeads.find(lead => lead.id === leadId);
      setSelectedLeads([...selectedLeads, selectedLead]);
    } else {
      setSelectedLeads(selectedLeads.filter(lead => lead.id !== leadId));
    }
  };

  return {
    leads,
    filteredLeads,
    selectedLeads,
    boats,
    isLoading,
    setSelectedLeads,
    loadLeads,
    handleBulkDelete,
    handleExport,
    handleFilter,
    handleSelectAll,
    handleLeadSelect,
    clearSelectedLeads
  };
};

export default useLeadActions;